export default __webpack_public_path__ + "static/media/like.19554337.svg";